import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type Message = {
  code: string;
  type: 'INFO' | 'ERROR';
  key: string;
};

export type MessageState = {
  messages: Message[];
};

const initialState: MessageState = {
  messages: [],
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    addMessage: (state, { payload }: PayloadAction<Message>) => {
      // Only display a message of a code once to avoid duplications
      if (state.messages.some((message) => message.code === payload.code)) {
        return state;
      }

      const messages = [...state.messages, payload];

      return {
        ...state,
        messages,
      };
    },
    removeFirstMessage: (state) => {
      const messages = state.messages.slice(1);

      return {
        ...state,
        messages,
      };
    },
  },
});

export const { addMessage, removeFirstMessage } = messageSlice.actions;

export const { reducer: messageReducer } = messageSlice;
